import { GET_ALL_DRIVERS, UPDATE_HIGHLIGHTED_DRIVER, CLEAR_HIGHLIGHTED_DRIVER, UPDATE_DRIVERS, UPDATE_DRIVER_FILTER } from '../constants';
const INITIAL_STATE = {
    drivers: [],
    driver: {
        selected: null,
        highlighted: null,
        filter: {
            free: true,
            busy: true,
            returning: true,
        }
    }
};

const driversReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_DRIVERS:
            return {
                ...state,
                drivers: action.drivers
            }
        case UPDATE_HIGHLIGHTED_DRIVER:
            return {
                ...state,
                driver: {
                    highlighted: action.driver,
                    selected: null,
                    filter: {
                        free: true,
                        busy: true,
                        returning: true,
                    }
                }
            }
        case CLEAR_HIGHLIGHTED_DRIVER:
            return {
                ...state,
                driver: {
                    highlighted: null,
                    selected: null,
                    filter: {
                        free: true,
                        busy: true,
                        returning: true,
                    }
                }
            }
        case UPDATE_DRIVERS:
            const newArr = state.drivers.map((obj) => {
                let newObj = Object.assign({}, obj);
                if (newObj.id === action.driver[0].id) {
                    newObj = action.driver[0];
                }
                return newObj;
            });
            return {
                ...state,
                drivers: newArr
            }
        case UPDATE_DRIVER_FILTER: {
            let newDriver = Object.assign({}, state.driver);
            newDriver.filter[action.action] = !newDriver.filter[action.action]
            return {
                ...state,
                driver: newDriver
            }
        }
        default:
            return state
    }
}

export default driversReducer;